import IconComponentsPlugin from './components/index.js'

let installed = false

export function setupIcons(app) {
	if (installed) {
	    console.warn('[Icon??] setupIcons already called')
	    return
	}
	installed = true
	
	app.use(IconComponentsPlugin)
}